export default __webpack_public_path__ + "static/media/TG.0502024a.svg";